import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

function useDetailedResults({
  token,
  masseuse,
  page,
  page_size,
  start_date,
  end_date,
  session,
  question,
  aggregate,
}) {
  const fetchSessionResultList = async () => {
    const params = {
      page: page ?? '',
      page_size: page_size ?? '',
      masseuse: masseuse ?? '',
      session: session ?? '',
      start_date: start_date ?? '',
      end_date: end_date ?? '',
      question: question ?? '',
      score: true,
      order_by: 'question',
      aggregate: aggregate ?? '',
    };

    try {
      const { data } = await api.get('/answers/', {
        params,
        headers: { Authorization: token },
      });

      return data;
    } catch (error) {
      throw new Error('Failed to fetch Simple List');
    }
  };

  const queryKey = [
    'sessionResultList',
    question,
    start_date,
    end_date,
    aggregate,
    page_size,
  ];

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: fetchSessionResultList,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  return {
    rows: data,
    isLoading,
    error,
  };
}

export default useDetailedResults;
